module.exports = __webpack_public_path__ + "img/bg_event_calendar_section.204e63aa.png";